// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1639":"48d96c3b","8503":"0bfe87d9","9737":"b6fb88ff"}[chunkId] + ".chunk.css";
};